// extracted by mini-css-extract-plugin
var _1 = "PanelIconSettings_active__0da4b";
var _2 = "PanelIconSettings_root__8e543";
export { _1 as "active", _2 as "root" }
